<!-- <app-header #header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<link rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
<div class="main">

  <div class="row m-0 imp">

    <div class="user-details col-12 col-lg-5 col-md-6 px-0 p-3">
      <div class="user-icons d-inline-flex">

        <span  class="ml-2 profile_icons" (click)="naviagateToEmployeeDetails()">Edit<span
            class="material-symbols-outlined fs-14">
            edit
          </span></span>
      </div>
      <div class="userinfodiv">

        <div class="user-photo">
          <div class="photo">
            <img width="100%" height="100%" src="../../../assets/images/user_avtar.png" />
          </div>
        </div>
        <div class="user-info py-2">
          <div class="name">
            <span class="h5 fw-600 emp-name">{{employeeProfileInfo?.lastName}} {{employeeProfileInfo?.firstName}}</span>
            <span id="subtitle">{{employeeProfileInfo?.grade}} | {{employeeProfileInfo?.designation}}</span>
            <span id="subtitle">{{employeeProfileInfo?.employeeId}} | <span *ngIf='expYears > 0'>{{expYears}}
                Year(s)</span> <span *ngIf='expMonths > 0'> {{expMonths}} Month(s)</span> exp.</span>
            <div class="Status_resume_container">
              <div class="inpool "> {{ employeeProfileInfo?.isAvailable ?'In pool' : 'Billable' }}</div>
              <div class="resume-container">
                <div class="resume"> {{ employeeProfileInfo?.isResumeUploaded ?'Resume Uploaded' : 'Upload Resume' }}
                </div>
                <div style="margin-left: auto; margin-top: auto; margin-bottom: 2.25%;">
                  <span class="mr-1 col-xl-4" id="profileStatus" [style.background-color]="cardColor"
                    [style.color]="cardTextColor" [title]="getTooltipText(employeeProfileInfo?.employeeProfileStatus)">
                    {{cardText}}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div style="margin-left: auto; margin-top: auto; margin-bottom: 2.25%;">

        </div>
      </div>

      <div class="ml-3">
        <div class="row flex-row mt-5">
          <span class=" col-2 p-0 ml-3 competencytitle">Competency</span>
          <span class="col h6" *ngIf="competency">{{competency}}</span>
        </div>
        <hr>
        <div class="row flex-row">
          <span class=" col-2 p-0 ml-3 competencytitle">SubCompetency</span>
          <span class="col h6" *ngIf="subCompetencyName">{{subCompetencyName}}</span>
        </div>
        <hr>
        <div class="row d-flex flex-row">
          <span class="col-2 p-0 ml-3  skillsets">Skillsets</span>
          <div class="col-9 d-flex" *ngIf="skillList.length > 0">
            <div class="row">
              <div class="chip mr-2 mb-2" *ngFor="let skillSet of skillList?.slice(0,6)">
                <div class="col-md">
                  <i class="dot mr-1"
                    [ngStyle]="{'background-color': skillSet?.proficiency==3 ? '#15A055' : ( skillSet.proficiency==2 ? '#FF7A00' : '#9DA9CA') }"></i>
                  <span>{{skillSet.skill}}</span>
                </div>
              </div>
              <button *ngIf="skillList && skillList.length > 6" [title]="getPrimaryDefaultSkills(skillList)"
                class="chip btn bg-white p-2 d-flex justify-content-center">....</button>
            </div>
          </div>
        </div>
        <hr>

        <div class="row d-flex flex-row">
          <span class="col-2 p-0 ml-3 certification">Certifications</span>
          <span class="px-0 h6" *ngFor="let certificate of certifications; let last = last">
            {{ certificate}}
            <span *ngIf="!last">|&nbsp;</span>
          </span>
        </div>
        <hr>
        <div class="row d-flex flex-row display">
          <div class="col-2 p-0 ml-3 domain">Vertical</div>
          <div class="col">
            <div class="d-flex px-0 row" style="max-width: 30vw;">
              <span class="px-0 h6" *ngFor="let domain of domains; let last = last">
                {{ domain }}
                <span *ngIf="!last">|&nbsp;</span>
              </span>
            </div>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <div class="career col-12 col-lg-7">
      <img src="../../../assets/images/org-chat.png" alt="grade" srcset="">
    </div>
  </div>
</div>